import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_1756914702 from "../../../../../packages/component/src/components/overlay/demo/demo1.js?loadDemo";
import legacyImportDemo_2792621261 from "../../../../../packages/component/src/components/overlay/demo/demo2.js?loadDemo";
import legacyImportDemo_3501161356 from "../../../../../packages/component/src/components/overlay/demo/demo3.js?loadDemo";
import legacyImportDemo_1030528331 from "../../../../../packages/component/src/components/overlay/demo/demo4.js?loadDemo";
import legacyImportDemo_3320909834 from "../../../../../packages/component/src/components/overlay/demo/demo5.js?loadDemo";
import legacyImportDemo_3934940873 from "../../../../../packages/component/src/components/overlay/demo/demo6.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_1756914702,
  legacyImportDemo_2792621261,
  legacyImportDemo_3501161356,
  legacyImportDemo_1030528331,
  legacyImportDemo_3320909834,
  legacyImportDemo_3934940873,
  React
};